import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2f88d722&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f88d722')) {
      api.createRecord('2f88d722', component.options)
    } else {
      api.reload('2f88d722', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2f88d722&", function () {
      api.rerender('2f88d722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/social/Q&A/index.vue"
export default component.exports